import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject, _templateObject2;

var _excluded = ["onClickGetStarted"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled, { useTheme } from 'styled-components';
import { useMemo } from 'react';
import { th } from '@yoweb/ui/styles/utils/theme';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons';
import { CircleCheckIcon } from '@yoweb/ui/components/Icon';
import { Title, Text } from '@yoweb/ui/components/typography';
import { gridBase, media } from '@yoweb/ui/styles/utils';
import { Disclaimer } from './Disclaimer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var BenefitsSection = function BenefitsSection(props) {
  var _useTranslation = useTranslation('pricing'),
      t = _useTranslation.t;

  var onClickGetStarted = props.onClickGetStarted,
      rest = _objectWithoutProperties(props, _excluded);

  var benefits = useMemo(function () {
    return [{
      title: t('benefits-section.benefits.0.title'),
      text: t('benefits-section.benefits.0.text')
    }, {
      title: t('benefits-section.benefits.1.title'),
      text: t('benefits-section.benefits.1.text')
    }, {
      title: t('benefits-section.benefits.2.title'),
      text: t('benefits-section.benefits.2.text')
    }];
  }, []);
  return /*#__PURE__*/_jsx(Box, {
    mt: {
      _: 'medium1',
      md: 'large2',
      lg: 'medium3'
    },
    py: {
      _: 'large3',
      lg: 'xl2'
    },
    backgroundColor: "skyLight",
    "data-testid": "pricing-section-benefits",
    children: /*#__PURE__*/_jsxs(BoxContainerGrid, {
      px: {
        _: 'normal2',
        md: 'medium1',
        lg: 'small3'
      },
      mx: "auto",
      children: [/*#__PURE__*/_jsxs(PriceSection, {
        children: [/*#__PURE__*/_jsx(PriceHeader, _objectSpread({}, rest)), /*#__PURE__*/_jsx(Box, {
          mt: "normal4",
          display: "flex",
          justifyContent: {
            _: 'center',
            lg: 'start'
          },
          children: /*#__PURE__*/_jsx(Button, {
            size: "lg",
            "data-testid": "pricing-benefits-get-started-btn",
            onClick: onClickGetStarted,
            type: "button",
            children: t('benefits-section.cta-text')
          })
        }), /*#__PURE__*/_jsx(Box, {
          mt: "normal3",
          children: /*#__PURE__*/_jsx(Disclaimer, _objectSpread({}, rest))
        })]
      }), /*#__PURE__*/_jsx(BenefitItems, {
        children: benefits.map(function (benefit) {
          return /*#__PURE__*/_jsxs(BenefitItem, {
            "data-testid": "pricing-benefits-item",
            children: [/*#__PURE__*/_jsx(Box, {
              mt: "small1",
              children: /*#__PURE__*/_jsx(Title, {
                size: "xs",
                children: benefit.title
              })
            }), /*#__PURE__*/_jsx(Box, {
              mt: "normal2",
              children: /*#__PURE__*/_jsx(TextNewLines, {
                size: {
                  _: 'md',
                  lg: 'lg'
                },
                variant: "muted",
                children: benefit.text
              })
            })]
          }, benefit.title);
        })
      })]
    })
  });
};

var PriceHeader = function PriceHeader(props) {
  var _useTranslation2 = useTranslation('pricing'),
      t = _useTranslation2.t;

  var basePrice = props.basePrice,
      hasCoupon = props.hasCoupon,
      useSubscriptionTrialRepeatingUi = props.useSubscriptionTrialRepeatingUi,
      useSubscriptionTrialOnceUi = props.useSubscriptionTrialOnceUi,
      discountPrice = props.discountPrice,
      discountMonths = props.discountMonths,
      discountAmountFull = props.discountAmountFull,
      initialOfferMonths = props.initialOfferMonths,
      initialOfferDays = props.initialOfferDays,
      initialOfferPrice = props.initialOfferPrice,
      initialOfferPriceFormatted = props.initialOfferPriceFormatted;

  if (useSubscriptionTrialRepeatingUi) {
    return /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      flexDirection: "column",
      alignItems: {
        _: 'center',
        lg: 'start'
      },
      children: [/*#__PURE__*/_jsx(Title, {
        children: // Special case if the initial offer period is free - copy should say "free" instead of money amount.
        initialOfferPrice === 0 ? /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "common.price-line-1-combo-free",
          values: {
            count: initialOfferMonths
          }
        }) : /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "common.price-line-1-combo",
          values: {
            count: initialOfferMonths,
            initialOfferPrice: initialOfferPriceFormatted
          }
        })
      }), /*#__PURE__*/_jsx(TitleSecondLine, {
        size: "xs",
        weight: "regular",
        variant: "muted3",
        children: /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "benefits-section.discount.price-line-2-combo",
          components: [/*#__PURE__*/_jsx(Title, {
            as: "span",
            size: "xs",
            weight: "bold",
            variant: "fg"
          }, 0)],
          values: {
            basePrice: basePrice,
            discountPrice: discountPrice,
            count: discountMonths,
            discountAmountFull: discountAmountFull
          }
        })
      }, 0)]
    });
  } else if (useSubscriptionTrialOnceUi) {
    var priceOfferLineKey = 'benefits-section.discount.price-offer-line-months';
    var count = initialOfferMonths;

    if (initialOfferDays && initialOfferDays > 0) {
      priceOfferLineKey = 'benefits-section.discount.price-offer-line-days';
      count = initialOfferDays;
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "baseline",
        justifyContent: {
          _: 'center',
          lg: 'start'
        },
        children: /*#__PURE__*/_jsx(Title, {
          size: {
            _: 'xl',
            lg: 'xxl'
          },
          weight: "regular",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: "common.price-line-subscription-trial",
            values: {
              initialOfferPrice: initialOfferPriceFormatted
            }
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        mt: "small3",
        children: /*#__PURE__*/_jsx(Title, {
          size: "xs",
          weight: "regular",
          textAlign: {
            _: 'center',
            lg: 'left'
          },
          variant: "muted",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: priceOfferLineKey,
            components: [/*#__PURE__*/_jsx(Title, {
              as: "span",
              size: "xs",
              weight: "bold",
              variant: "fg"
            }, 0)],
            values: {
              count: count,
              discountAmountFull: discountAmountFull
            }
          })
        })
      })]
    });
  } else if (hasCoupon) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "baseline",
        justifyContent: {
          _: 'center',
          lg: 'start'
        },
        children: /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "benefits-section.discount.price-line",
          components: [/*#__PURE__*/_jsx(Title, {
            size: {
              _: 'xl',
              lg: 'xxl'
            },
            weight: "regular"
          }, 0), /*#__PURE__*/_jsx(Title, {
            size: "sm"
          }, 1), /*#__PURE__*/_jsx(TitleStrikeMargin, {
            size: "sm",
            weight: "regular",
            variant: "muted"
          }, 2)],
          values: {
            basePrice: basePrice,
            discountPrice: discountPrice
          }
        })
      }), /*#__PURE__*/_jsx(Box, {
        mt: "small3",
        children: /*#__PURE__*/_jsx(Title, {
          size: "xs",
          weight: "regular",
          textAlign: {
            _: 'center',
            lg: 'left'
          },
          variant: "muted",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: "benefits-section.discount.price-offer-line-months",
            components: [/*#__PURE__*/_jsx(Title, {
              as: "span",
              size: "xs",
              weight: "bold",
              variant: "fg"
            }, 0)],
            values: {
              count: discountMonths,
              discountAmountFull: discountAmountFull
            }
          })
        })
      })]
    });
  }

  return /*#__PURE__*/_jsx(Box, {
    display: "flex",
    alignItems: "baseline",
    justifyContent: {
      _: 'center',
      lg: 'start'
    },
    children: /*#__PURE__*/_jsx(Trans, {
      t: t,
      i18nKey: "common.price-line",
      components: [/*#__PURE__*/_jsx(Title, {
        size: {
          _: 'xl',
          lg: 'xxl'
        },
        weight: "regular"
      }, 0), /*#__PURE__*/_jsx(Title, {
        size: "sm"
      }, 1)],
      values: {
        basePrice: basePrice
      }
    })
  });
};

var BenefitItem = function BenefitItem(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded2);

  var theme = useTheme();
  return /*#__PURE__*/_jsxs(BenefitGrid, _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(CircleCheckIcon, {
        size: theme.iconSizes["default"]
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: children
    })]
  }));
}; // Benefits section components styles


var BoxContainerGrid = styled(Box).withConfig({
  componentId: "sc-1oe41eb-0"
})(["&&{max-width:", ";", ";}"], th.getSize('containerWidth'), gridBase);
var BenefitGrid = styled.div.withConfig({
  componentId: "sc-1oe41eb-1"
})(["display:grid;column-gap:", ";grid-template-columns:min-content 1fr;"], th.getSpace('normal1'));
var PriceSection = styled.div.withConfig({
  componentId: "sc-1oe41eb-2"
})(["grid-column:1/-1;", ""], media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-column: 1/6;\n  "]))));
var BenefitItems = styled.div.withConfig({
  componentId: "sc-1oe41eb-3"
})(["display:grid;grid-column:1/-1;row-gap:", ";margin-top:", ";", ""], th.getSpace('normal3'), th.getSpace('medium2'), media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: 0;\n    grid-column: 6/-1;\n  "]))));
var TextNewLines = styled(Text).withConfig({
  componentId: "sc-1oe41eb-4"
})(["&&{white-space:pre-line;}"]);
var TitleSecondLine = styled(Title).withConfig({
  componentId: "sc-1oe41eb-5"
})(["&&{margin-top:", ";text-align:center;}"], th.getSpace('small4'));
var TitleStrikeMargin = styled(Title).withConfig({
  componentId: "sc-1oe41eb-6"
})(["&&{text-decoration:", " line-through;margin-left:", ";}"], th.getColor('critical'), th.getSpace('normal1'));